import { createFileRoute } from '@tanstack/react-router';
import { LrcEditorPage } from '@/page/LrcEditorPage';

/** The lyric editor for a track's owner; admins reach the same page under
 * /admin. tracks.updateLyrics checks owner-or-admin server-side either way. */
export const Route = createFileRoute('/_app/tracks/$trackId/lyrics')({ component: LrcEditorRoute });

function LrcEditorRoute() {
  const { trackId } = Route.useParams();
  return <LrcEditorPage trackId={trackId} />;
}
